import HttpService from '../http-service';

const isNode = typeof __webpack_require__ === 'undefined'; //eslint-disable-line

export default class IPAddressService {
  static ipAddress = '';
  static initialized = false;

  static initialize() {
    if (
      isNode ||
      typeof IS_PHANTOM_JS !== 'undefined' ||
      IPAddressService.initialized
    ) {
      return;
    }
    IPAddressService.initialized = true;
    const interval = 30 * 60000;
    setInterval(IPAddressService.getIPAddress, interval);
    IPAddressService.getIPAddress();
  }

  static getIPAddress() {
    HttpService.get({ url: '/getIPAddress' }).then(result => {
      IPAddressService.ipAddress = result.data;
    });
  }
}

IPAddressService.initialize();
